import { Component, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  templateUrl: './new-portal-version-warning.component.html',
  styleUrls: ['./new-portal-version-warning.component.scss'],
  imports: [MatButton, MatIcon],
})
export class NewPortalVersionWarningComponent {
  swUpdate = inject(SwUpdate);
  private snackRef = inject<MatSnackBarRef<NewPortalVersionWarningComponent>>(MatSnackBarRef);

  public reloadApp() {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
    this.snackRef.dismiss();
  }
}
